var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "send-email-config" },
    [
      _c(
        "div",
        { staticClass: "config-field" },
        [
          _c("label", [_vm._v("Gönderici (From)")]),
          _vm._v(" "),
          _c(
            "a-select",
            {
              staticStyle: { width: "100%" },
              attrs: {
                "show-search": "",
                placeholder: "Gönderici mail adresi seçin",
              },
              on: { change: _vm.emitChange },
              model: {
                value: _vm.localConfig.from,
                callback: function ($$v) {
                  _vm.$set(_vm.localConfig, "from", $$v)
                },
                expression: "localConfig.from",
              },
            },
            _vm._l(_vm.senderMails, function (mail) {
              return _c(
                "a-select-option",
                { key: mail.mail, attrs: { value: mail.mail } },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(mail.mail) +
                      " (" +
                      _vm._s(_vm.getMailLabel(mail)) +
                      ")\n            "
                  ),
                ]
              )
            }),
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "config-field" },
        [
          _c("label", [_vm._v("Alıcı Tipi (To)")]),
          _vm._v(" "),
          _c(
            "a-radio-group",
            {
              attrs: { "button-style": "solid" },
              on: { change: _vm.emitChange },
              model: {
                value: _vm.localConfig.toType,
                callback: function ($$v) {
                  _vm.$set(_vm.localConfig, "toType", $$v)
                },
                expression: "localConfig.toType",
              },
            },
            [
              _c("a-radio-button", { attrs: { value: "static" } }, [
                _vm._v("Sabit E-posta"),
              ]),
              _vm._v(" "),
              _c("a-radio-button", { attrs: { value: "dynamic" } }, [
                _vm._v("Dinamik"),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.localConfig.toType === "static"
        ? _c(
            "div",
            { staticClass: "config-field" },
            [
              _c("label", [_vm._v("Alıcı E-posta Adresleri")]),
              _vm._v(" "),
              _c("a-select", {
                staticStyle: { width: "100%" },
                attrs: { mode: "tags", placeholder: "E-posta adresleri girin" },
                on: { change: _vm.emitChange },
                model: {
                  value: _vm.localConfig.toStatic,
                  callback: function ($$v) {
                    _vm.$set(_vm.localConfig, "toStatic", $$v)
                  },
                  expression: "localConfig.toStatic",
                },
              }),
              _vm._v(" "),
              _c("small", [
                _vm._v(
                  "E-posta adreslerini virgül ile ayırarak girebilirsiniz"
                ),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.localConfig.toType === "dynamic"
        ? _c(
            "div",
            { staticClass: "config-field" },
            [
              _c("label", [_vm._v("Dinamik Alıcılar")]),
              _vm._v(" "),
              _c(
                "a-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    mode: "multiple",
                    placeholder: "Dinamik alıcı seçin",
                  },
                  on: { change: _vm.emitChange },
                  model: {
                    value: _vm.localConfig.toDynamic,
                    callback: function ($$v) {
                      _vm.$set(_vm.localConfig, "toDynamic", $$v)
                    },
                    expression: "localConfig.toDynamic",
                  },
                },
                [
                  _c("a-select-option", { attrs: { value: "task_owner" } }, [
                    _vm._v("Görev Sahibi"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "a-select-option",
                    { attrs: { value: "task_assignees" } },
                    [_vm._v("Görev Atananları")]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-select-option",
                    { attrs: { value: "task_followers" } },
                    [_vm._v("Görev Takipçileri")]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-select-option",
                    { attrs: { value: "task_collaborators" } },
                    [_vm._v("Görev İşbirlikçileri")]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-select-option",
                    { attrs: { value: "task_relation_visitor" } },
                    [_vm._v("İlişkili Müşteri")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "config-field" },
        [
          _c("label", [_vm._v("CC (opsiyonel)")]),
          _vm._v(" "),
          _c("a-select", {
            staticStyle: { width: "100%" },
            attrs: { mode: "tags", placeholder: "CC e-posta adresleri" },
            on: { change: _vm.emitChange },
            model: {
              value: _vm.localConfig.cc,
              callback: function ($$v) {
                _vm.$set(_vm.localConfig, "cc", $$v)
              },
              expression: "localConfig.cc",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "config-field" },
        [
          _c("label", [_vm._v("BCC (opsiyonel)")]),
          _vm._v(" "),
          _c("a-select", {
            staticStyle: { width: "100%" },
            attrs: { mode: "tags", placeholder: "BCC e-posta adresleri" },
            on: { change: _vm.emitChange },
            model: {
              value: _vm.localConfig.bcc,
              callback: function ($$v) {
                _vm.$set(_vm.localConfig, "bcc", $$v)
              },
              expression: "localConfig.bcc",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "config-field" }, [
        _c("label", [_vm._v("Konu (Subject)")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "input-with-variables" },
          [
            _c("a-input", {
              attrs: {
                placeholder:
                  "E-posta konusu ({{task.title}} gibi dinamik değişkenler kullanabilirsiniz)",
              },
              on: { change: _vm.emitChange },
              model: {
                value: _vm.localConfig.subject,
                callback: function ($$v) {
                  _vm.$set(_vm.localConfig, "subject", $$v)
                },
                expression: "localConfig.subject",
              },
            }),
            _vm._v(" "),
            _c(
              "a-button",
              {
                attrs: { type: "link", size: "small" },
                on: {
                  click: function ($event) {
                    _vm.showVariablesPicker = true
                  },
                },
              },
              [
                _c("i", { staticClass: "material-icons" }, [_vm._v("code")]),
                _vm._v("\n                Değişkenler\n            "),
              ]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "config-field" }, [
        _c("label", [_vm._v("İçerik (Body)")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "input-with-variables" },
          [
            _c("a-textarea", {
              attrs: {
                placeholder:
                  "E-posta içeriği (HTML desteklenir, {{task.description}} gibi dinamik değişkenler kullanabilirsiniz)",
                rows: 6,
              },
              on: { change: _vm.emitChange },
              model: {
                value: _vm.localConfig.body,
                callback: function ($$v) {
                  _vm.$set(_vm.localConfig, "body", $$v)
                },
                expression: "localConfig.body",
              },
            }),
            _vm._v(" "),
            _c(
              "a-button",
              {
                attrs: { type: "link", size: "small" },
                on: {
                  click: function ($event) {
                    _vm.showVariablesPicker = true
                  },
                },
              },
              [
                _c("i", { staticClass: "material-icons" }, [_vm._v("code")]),
                _vm._v("\n                Değişkenler\n            "),
              ]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c("small", [
          _vm._v(
            "HTML etiketleri kullanabilirsiniz. Örn: <b>kalın</b>, <br> satır atla"
          ),
        ]),
      ]),
      _vm._v(" "),
      _vm.showVariablesPicker
        ? _c("DynamicVariablesPicker", {
            attrs: { visible: _vm.showVariablesPicker },
            on: {
              close: function ($event) {
                _vm.showVariablesPicker = false
              },
              select: _vm.insertVariable,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }